import React, { useContext } from 'react';

import { RuleEditorContext } from '../../NodeEditorDrawer/context';
import { CaretPositionSuffixTypes } from '../../NodeEditorDrawer/types';
import { Caret, HiddenCaret } from './styles';


function MorphingCaret({
  position,
  children,
  canShowGroupCloseSuggestion = false,
}: {
  position: string | undefined;
  children: React.ReactNode;
  canShowGroupCloseSuggestion?: boolean;
}) {
  const {
    morphingCaretPosition,
    setMorphingCaretPosition,
  } = useContext(RuleEditorContext);

  const isCaretActivatedForAction = morphingCaretPosition === `${position}${CaretPositionSuffixTypes.CARET_INSERTION}`;

  const onClickHiddenCaret = () => setMorphingCaretPosition(`${position}${CaretPositionSuffixTypes.CARET_INSERTION}`);

  return isCaretActivatedForAction ? (
    <Caret>
      {children}
    </Caret>
  ) : (
    <HiddenCaret
      onClick={onClickHiddenCaret}
      inlineSuggestion={canShowGroupCloseSuggestion}
    >
      {canShowGroupCloseSuggestion ? ')' : ''}
    </HiddenCaret>
  );
}

export default MorphingCaret;
